import React from "react";
import { FinancialConnection } from "@common/types/financialConnection";
import { IntegrationAccount } from "@common/types/integrationAccount";
import { IntegrationConnection } from "@common/types/integrationConnection";
import { isPlaidConnection } from "@common/helpers/financialConnection";
import { isIntegrationConnection } from "@common/helpers/integrationConnection";
import { UnsupportedPlaidConnection } from "@components/plaid/UnsupportedPlaidConnection";
import {
    ConnectionActionButton,
    ConnectionButtonAppearance,
} from "./ConnectionActionButton";
import { ConnectionFixer } from "./ConnectionFixer";

interface Props extends ConnectionButtonAppearance {
    connection: FinancialConnection | IntegrationConnection;
    integrationAccount?: IntegrationAccount;
    onFixed?: () => void;
    children: React.ReactNode;
}

export const FixConnectionButton: React.FC<Props> = ({
    connection,
    integrationAccount,
    onFixed,
    children,
    ...appearance
}) => (
    <ConnectionFixer
        connection={connection}
        integrationAccount={integrationAccount}
        onFixed={onFixed}
    >
        {(fix) => {
            if (fix.canFix) {
                return (
                    <ConnectionActionButton
                        loading={fix.isFixing}
                        onClick={fix.startFix}
                        {...appearance}
                    >
                        {children}
                    </ConnectionActionButton>
                );
            }
            if (
                !isIntegrationConnection(connection) &&
                isPlaidConnection(connection)
            ) {
                return <UnsupportedPlaidConnection error={connection.error} />;
            }
            return null;
        }}
    </ConnectionFixer>
);
